import { ResourceFilter } from "../../domains/TimelineResourceFilter";
import { useFetchTimelineStudyRecords } from "../../hooks/http/useFetchTimelineStudyRecords";
import { useMergedTimeline } from "../../hooks/useMergedTimeline";
import { useQueryString } from "../../hooks/useQueryString";
import { useTimelineDrillProgress } from "../../hooks/useTimelineDrillProgress";

type Props = {
  sectionId: string;
  resourceFilter: ResourceFilter;
  enabled: boolean;
};

// 校舎リアルタイムタブの統合ストリーム。AI 質問統合表示の凍結
// （005-freeze-ai-question-timeline）に伴い、学習記録ソースのみを扱う。
// resourceFilter は骨格として引数に残す（URL クエリ経由の状態は維持されるが、
// 凍結中はソース選択に用いない。凍結解除時に AI 質問ソースを再度差し込む）。
export const useMergedRealtimeTimeline = ({
  sectionId,
  resourceFilter,
  enabled,
}: Props) => {
  // resource_filter（フロント専用のソース選択）と date（サマリー固有）はバックエンドの
  // 取得条件ではないため、送信せずキャッシュキーにも含めない。
  const queryParams = { ...useQueryString() };
  delete queryParams.resource_filter;
  delete queryParams.date;

  // student_id 未指定 = 校舎全体（リアルタイム）。
  const studyQuery = useFetchTimelineStudyRecords({
    sectionId,
    queryParams,
    enabled,
  });

  const { displayed, isLoading, isFetchingNextPage } = useMergedTimeline({
    studySource: {
      items: studyQuery.data ?? [],
      hasNextPage: !!studyQuery.hasNextPage,
      isFetchingNextPage: studyQuery.isFetchingNextPage,
      fetchNextPage: studyQuery.fetchNextPage,
      isLoading: studyQuery.isLoading,
      error: studyQuery.error,
    },
    // フィルタ変更で表示ページ数をリセットする（骨格維持: URL クエリ変更に追従）
    resetKey: resourceFilter,
  });

  // ドリル学習定着バー（学習記録固有）。表示中のドリル学習記録を対象に取得する。
  const drillProgressMap = useTimelineDrillProgress(sectionId, displayed);

  return {
    displayed,
    isLoading,
    isFetchingNextPage,
    updateStudyRecordQueryCache: studyQuery.updateStudyRecordQueryCache,
    drillProgressMap,
  };
};
